<template>
  <!-- Chat box -->
  <div class="box box-success">
    <div class="box-header">
      <i class="fa fa-comments-o"></i>

      <h3 class="box-title">{{$t('task_log')}}</h3>

      <div class="box-tools pull-right" data-toggle="tooltip" title="Status">
        <div class="btn-group" data-toggle="btn-toggle">
          <button type="button" class="btn btn-default btn-sm active" @click="filter(-1,$event)"><i class="fa fa-list fa-2x text-info"></i>
          </button>
          <button type="button" class="btn btn-default btn-sm"  @click="filter(3,$event)"><i class="fa fa-headphones fa-2x text-primary"></i>
          </button>
          <button type="button" class="btn btn-default btn-sm"  @click="filter(4,$event)"><i class="fa fa-ambulance fa-2x text-green"></i></button>
          <button type="button" class="btn btn-default btn-sm"  @click="filter(5,$event)"><i class="fa fa-medkit fa-2x text-danger"></i></button>
          <button type="button" class="btn btn-default btn-sm"  @click="filter(6,$event)"><i class="fa fa-user-md fa-2x text-warning"></i></button>
        </div>
      </div>
    </div>
    <div class="box-body chat id-chat-box">
      <!-- chat item -->
      <div class="item" v-for="task in tasks" :key="task.id">
        <img src="~admin-lte/dist/img/user4-128x128.jpg" alt="user image" class="online">

        <p class="message">
         
            <small class="text-muted pull-right"><i class="fa fa-clock-o"></i> {{ moment(task.insertTime).startOf('hour').fromNow()   }}</small>
            <a href="#" @click="showUser(task.enterBy)">{{task.enterBy}}</a>   - > <a href="#" @click="showUser(task.contactNumber)">{{task.contactNumber}}</a> <br/>
        
          {{ $t('tasklist')[[task.taskGroup-3]] }}
         
        </p>
        
          
          
          <div v-if="task.taskGroup==6" class="border border-warning">
          <h4>{{$t('medicine_list')}}</h4>
          <table class="table table-striped">
             <tbody>
             <tr class="filename" v-for="med in task.medicines" :key="med.id">
              <td>
                 {{ med.name }}<br/>
                 {{ $t('medicineType')[[med.productType]] }}  {{ $t('medicineGroups')[[med.groupName]] }}
                
              </td>
              <td>{{ $t('quantityData')[[med.quantity]] }} <span v-if="med.productType==2">{{$t('spoon')}}</span></td>
              <td>{{ $t('durationData')[[med.duration]] }}</td>
              <td>{{ $t('beforeAftermealData')[[med.beforeAfterMeal]] }}</td>
           </tr>
           </tbody>
          </table>
          </div>
          <div v-else>
            <table class="table table-striped">
             <tbody>
             <tr class="filename" v-for="log in task.taskLog" :key="log.id">
              <td>
                  <span v-if="task.taskGroup==3">{{ $t('consultantTasks')[[log.task]] }}</span>
                  <span v-if="task.taskGroup==4">{{ $t('ambulanceTasks')[[log.task]] }}</span>
                  <span v-if="task.taskGroup==5">{{ $t('deliveryTasks')[[log.task]] }}</span>
                
              </td>
              <td>{{log.comments}}</td>
              <td>{{log.updateBy}}</td>
              <td>{{log.updateTime}}</td>
           </tr>
           </tbody>
          </table>
          </div>
        <hr class="text-success"/>
        <!-- /.attachment -->
      </div>
      <!-- /.item -->
      <!-- chat item -->
    
    
    </div>
    <!-- /.chat -->
    <div class="box-footer">
      <div class="input-group">
        <input class="form-control" placeholder="Type message...">

        <div class="input-group-btn">
          <button type="button" class="btn btn-success"><i class="fa fa-plus"></i></button>
        </div>
      </div>
    </div>
  </div>
  <!-- /.box (chat box) -->
</template>

<script>
import { services } from '../../src/vuex/api'
import i18n from '../plugins/i18n' 
export default {
  name: 'ChatBox',
  props:{
    patient: Object
  },
  data(){
    return {
        error:'',
        tasks:[],
        originTasks:[]
    }
  },
  created(){
   // alert('geee')
  this.getTasklist()
  },
  mounted () {
    var chatBoxElement = this.$el.querySelector('.id-chat-box')
    if ( localStorage.getItem('lan') != null ) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language
    $(chatBoxElement).slimScroll({
      height: '250px'
    })
  },
  methods: {
    filter:function(num,e){
       var self = this
      e.preventDefault()
   if (num < 0) {
     self.tasks = self.originTasks
   } else {
    self.tasks = self.originTasks.filter(function(task) {
    return task.taskGroup === num
    })
   }
    },
    submitPrescription(e){
     var self = this
     e.preventDefault()
    },
  getTasklist: function ( ) {
    var self = this
    self.loading = true 
    var search = { patientId:self.patient.id }
    services.Task.getTask(search) //  .getPatientInfo()
    .then(function (response) {
      // console.log(JSON.stringify(response.data))
      self.originTasks = response.data.docs
      self.tasks = self.originTasks
      // self.loading = false 
       self.loading = false 
    })
    .catch(function (err) {
      self.error = '' + err
      self.loading = false 
    })
  },
  showUser:function(contactNumber){
    alert(contactNumber)
  },
   searchMedicineClick: function (e){
      e.preventDefault()
    this.getMedicines()
  },
  clearMedicineClick: function (e){
    e.preventDefault()
  },
 }
}
</script>



// WEBPACK FOOTER //
// VAChatBox.vue?63e9c9f0